<template>
 <div class="backdrop" @click="closeSelectLanguageModal">
    <div id="selectLanguageButtons">
        <button class="languageButton" @click="selectLanguage('English')">English</button><br>
        <button class="languageButton" @click="selectLanguage('Sinhala')">Sinhala</button><br>
        <button class="languageButton" @click="selectLanguage('Tamil')">Tamil</button><br>
 </div>
 </div>
</template>

<script>
export default {
        methods:{
            selectLanguage:function(language){
                console.log("Selected Language : "+language)
                // TODO:: handle language selection here
            },
            
            closeSelectLanguageModal:function(){
                this.$emit('close')
            },
        },

}
</script>

<style>
    #selectLanguageButtons{
        margin: 20% auto;
        background: transparent;

    }
    .backdrop{
        top: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        
    }

    .selectLanguageButtons > .is-primary{
        color: white;
    }

    .languageButton{
        width: 300px;
        height: 50px;
        border-radius: 50px;
        border: 2px solid #0d5da3;
        color: #0d5da3;
        font-size: 1rem;
        font-weight: bold;
        margin-bottom: 30px;
    }
    .languageButton:hover{
        color: white;
        background-color: #0d5da3;
    }
</style>